import Vue from 'vue'
import Vuex from 'vuex'
import moondays from './moondays'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    moondays
  }
})
